import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { hash } from 'rsvp'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type FastPhonicsDashStudentRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/dashboard/student/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class FastPhonicsReportingStudentDashboardTableRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor(
      'reporting.ui-scope.fast-phonics.dashboard.student',
    ) as ModelFor<FastPhonicsDashStudentRoute>

    const statsScope: StudentsScope = { scope: 'students', ids: [student.id] }
    const product: LegacyProductFp = 'fast_phonics'

    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      students: scopedData.students,
      student,
      period,
      ...stats,
    }
  }

  makeStatsRequests = (product: LegacyProductFp, scope: StudentsScope, period: NormalizedInterval) => {
    return hash({
      studentData: this.studentEvents.studentSummary(product, scope, period),
    })
  }
}
